<template>
    <div class="main">
        <div v-if="REGISTER===false">
            <h1 class="title">新用户注册</h1>
            <div>
                <van-cell-group>
                    <van-field placeholder="请填写手机号" v-model="PHONE_NUM">
                        <van-button slot="button" size="small" type="primary" @click="sendVerifyCode" :disabled="sendVerifyDisabled" v-text="verifyText"></van-button>
                    </van-field>
                    <van-field placeholder="请填写验证码" v-model="CODE" />
                </van-cell-group>
            </div>
            <!-- <div class="regist">
                <a @click="register">新用户注册</a>
            </div> -->
            <div class="btndiv">
                <button type="button" class="login" @click="confirm" >确认</button>
                <!-- <button type="button" class="login" @click="register">注册</button> -->
            </div>
        </div>
        <div v-else>
            <register @LOGIN="finish" :PHONE_NUM="PHONE_NUM" :CODE="CODE"></register>
        </div>
    </div>
</template>

<script>
    import api from "@/fetch/api";
    import register from '@/pages/personRegister';
    import {
        Dialog,
        Toast
    } from 'vant';
    import {
        mapActions
    } from 'vuex';
    import md5 from 'js-md5';
    export default {
        data() {
            return {
                ID_CARD: '',
                PHONE_NUM: '',
                CODE: '',
                REAL_CODE: '',
                REGISTER: false,
                DATA: {
                    currentCustomerName: '',
                    currentCustomerId: '',
                    token:''
                },
                sendVerifyDisabled: false,
                verifyText: '发送验证码',
                verifySecond: 60,
                timer: null
            }
        },
        components: {
            register
        },
        methods: {
            ...mapActions({
                setUserInfo: "setUserInfo",
                setBasicData: "setBasicData"
            }),
            finish(val) {
                if (val == true) {
                    this.REGISTER = false;
                    this.$emit('finish', true);
                    // var data = JSON.parse(sessionStorage.getItem('AYUserLogin'));
                    // this.ID_CARD = data.ID_CARD;
                    // this.PHONE_NUM = data.PHONE_NUM;
                } else {
                    this.REGISTER = false;
                }
            },
            sendVerifyCode() {
                if (this.sendVerifyDisabled === false) {
                    
                    if (!this.PHONE_NUM) {
                        Toast.fail('请填写手机号');
                        return false;
                    }
                    this.sendVerifyDisabled = true;
                    let params = {
                        ID_CARD: this.ID_CARD,
                        PHONE_NUM: this.PHONE_NUM
                    };
                    api.getRegCode(params).then(re => {
                        console.log(re);
                        if (re.result == true) {
                            
                        } else {
                            Toast.fail(re.msg);
                        }
                    });
                    this.verifyText = '60s';
                    let that = this;
                    this.timer = setInterval(function() {
                        if (that.verifySecond == 1) {
                            clearInterval(that.timer);
                            that.verifyText = '重新发送';
                            that.verifySecond = 60;
                            that.sendVerifyDisabled = false;
                        } else {
                            that.verifySecond--;
                            that.verifyText = that.verifySecond + 's';
                        }
                    }, 1000);
                }
            },
            
            confirm() {
                if (this.PHONE_NUM == '') {
                    Toast.fail('请填写手机号！');
                    return false;
                }
                if (this.CODE == '') {
                    Toast.fail('请填写验证码！');
                    return false;
                }
                this.REGISTER = true;
            },
            register() {
                this.REGISTER = true;
            },
            getRequest() {
                var url = location.search; 
                if (url.indexOf("?") != -1) { 
                    var str = url.substr(7); 
                    strs = str.split("&state="); 
                    return (strs[1]); 
                }
            }
        },
        created() {
            window.scroll(0, 0);
        },
        mounted() {
            clearInterval(this.timer)
        },
        distroyed: function() {　　
            clearInterval(this.timer)
        }

    }
</script>

<style scoped lang="less">
    .title {
        text-align: center;
        padding: .5em 0;
        font-size: 1.8em;
    }
    .regist {
        padding: 1em;
        background: #fff;
        text-align: right;
        a {
            font-size: 0.8em;
            text-decoration: underline;
        }
    }
    .btndiv {
        text-align: center; // position: absolute;
        // bottom: 6rem;
        width: 100%;
        word-spacing: 1rem;
        padding: 2em 0;
        background: #fff;
    }
    .login {
        color: #ffffff;
        background-color: #74b13f;
        box-sizing: border-box;
        border: 1px solid #74b13f;
        border-radius: 5px;
        box-shadow: none;
        font-size: 1rem; // width: 6rem;
        width: 80%;
        height: 3em;
        text-align: center; // margin: 5rem 0.5rem;
    }
    .van-button {
        border-color: #74b13f;
        color: #74b13f;
        background-color: #fff;
        border-radius: 5px;
    }
    .register {
        color: #ffffff;
        background-color: #74b13f;
        box-sizing: border-box;
        border: 1px solid #74b13f;
        border-radius: 5px;
        box-shadow: none;
        font-size: 1rem;
        width: 6rem;
        height: 2.4rem;
        text-align: center;
        margin: 5rem 0.5rem;
    }
</style>


// WEBPACK FOOTER //
// src/pages/verifyingCode.vue